import cx from "classnames";
import React from "react";
import "./Typography.scss";

interface TypographyProps extends React.HTMLAttributes<HTMLParagraphElement> {
  variant: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "large" | "medium" | "regular" | "small" | "tiny";
}

const Typography: React.FC<TypographyProps> = (props) => {
  const { variant, className, ...rest } = props;

  const tagName = variant.startsWith("h") ? variant : "p";
  const isHeading = variant.startsWith("h");

  return React.createElement(
    tagName,
    { className: cx(`typography ${variant}`, { heading: isHeading }, className), ...rest },
    props.children
  );
};

export default Typography;
